import { render, staticRenderFns } from "./index.vue?vue&type=template&id=c31ead88"
import script from "./index.vue?vue&type=script&setup=true&lang=js"
export * from "./index.vue?vue&type=script&setup=true&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports

/* nuxt-component-imports */
installComponents(component, {VectorIcon: require('/var/www/html/fantini/frontend-2/components/vector/icon/index.vue').default,FormHubspot: require('/var/www/html/fantini/frontend-2/components/form/hubspot/index.vue').default,Modal: require('/var/www/html/fantini/frontend-2/components/modal/index.vue').default})
